<template>
    <v-form name="set-need-analysis-form">
        <div class="grid">
            <FormInputNumber fieldName="budget_real"
                             label="Real budget"
                             size="2"
                             :minFractionDigits="2"
                             :maxFractionDigits="2"
                             v-model:field="crud.budget_real" />
            <FormInputText fieldName="location"
                           label="Location"
                           size="5"
                           v-model:field="crud.location" />
            <FormInputText fieldName="surface"
                           label="Surface"
                           size="5"
                           v-model:field="crud.surface" />
        </div>
        <div class="grid">
            <FormCalendar fieldName="start_date"
                          label="Start date"
                          size="4"
                          v-model:field="crud.start_date" />

            <FormCalendar fieldName="expected_closing_date"
                          label="Expected closing date"
                          size="4"
                          v-model:field="crud.expected_closing_date" />

            <FormCalendar fieldName="nearest_contact_date"
                          label="Nearest contact date"
                          size="4"
                          v-model:field="crud.nearest_contact_date" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="setNeedAnalysis"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-circle-xmark"></i><span>{{ __('Save') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref } from 'vue'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    opportunityData: Object,
    formProps: Object,
    statuses: Array,
})

const isSetNeedAnalysisModalOpen = defineModel('isSetNeedAnalysisModalOpen')
const crud = ref(props.opportunityData)

// -----------------------------------------------------

const cancel = () => {
    isSetNeedAnalysisModalOpen.value = false
}
// -----------------------------------------------------

const setNeedAnalysis = async () => {
    const formData = {
        'id': props.opportunityData.id,
        'status_id': props.statuses.find(status => status.status_symbol === 'SYM_NEEDS_ANALYSIS')?.value ?? null,
        'budget_real': crud.value.budget_real,
        'location': crud.value.location,
        'surface': crud.value.surface,
        'start_date': crud.value.start_date,
        'expected_closing_date': crud.value.expected_closing_date,
        'nearest_contact_date': crud.value.nearest_contact_date
    }

    if (validation(formData, 'set-need-analysis-form')) {
        const response = await getFromRoute('opportunity-status-set', formData, 'post');
        screenMessage({ ...response })

        isSetNeedAnalysisModalOpen.value = false
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
